import { render, staticRenderFns } from "./TaskSectionSortMenu.vue?vue&type=template&id=3f3c3b1d"
import script from "./TaskSectionSortMenu.vue?vue&type=script&lang=ts"
export * from "./TaskSectionSortMenu.vue?vue&type=script&lang=ts"
import style0 from "./TaskSectionSortMenu.vue?vue&type=style&index=0&id=3f3c3b1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports